import { render, staticRenderFns } from "./UserWithAvatar.vue?vue&type=template&id=3bb56c1e"
import script from "./UserWithAvatar.vue?vue&type=script&lang=js"
export * from "./UserWithAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserWithAvatar.vue?vue&type=style&index=0&id=3bb56c1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports